'use client';

import React, { useEffect, useRef } from 'react';
import AppImage from '@/components/ui/AppImage';

interface Testimonial {
  quote: string;
  name: string;
  title: string;
  company: string;
  avatar: string;
  type: 'candidate' | 'employer';
  metric?: string;
  metricLabel?: string;
}

const testimonials: Testimonial[] = [
{
  type: 'candidate',
  quote: "I had 23 browser tabs open for three months. remotejobehire replaced all of them. The timezone filter alone saved me from two miserable offers.",
  name: 'Marcus Osei',
  title: 'Staff Product Manager',
  company: 'Previously at Intercom',
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_173ef4ef0-1768416524624.png",
  metric: '11 days',
  metricLabel: 'to signed offer'
},
{
  type: 'employer',
  quote: "We posted on every major board and got noise. On remotejobehire we got 14 qualified applicants in 48 hours. Three are still on our team.",
  name: 'Priya Nambiar',
  title: 'Head of Engineering',
  company: 'Doist',
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_10e6ce8e9-1770101756372.png",
  metric: '48 hrs',
  metricLabel: 'to first pipeline'
},
{
  type: 'candidate',
  quote: "Every role on here is actually remote — not 'remote with occasional travel' or 'remote, NYC preferred.' That distinction matters enormously.",
  name: 'Tobias Lindqvist',
  title: 'Senior Backend Engineer',
  company: 'Previously at Figma',
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_19c5df191-1771894444921.png",
  metric: '3 offers',
  metricLabel: 'in 6 weeks'
},
{
  type: 'employer',
  quote: "Our last three senior hires came through remotejobehire. The quality of candidates who understand async work culture is genuinely different here.",
  name: 'Amara Diallo',
  title: 'VP People & Culture',
  company: 'Automattic',
  avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1fa58e105-1772069217581.png",
  metric: '3 of 4',
  metricLabel: 'senior hires via remotejobehire'
},
{
  type: 'candidate',
  quote: "After six months of applying on generic job boards, I landed a senior design role in two weeks through remotejobehire. The job descriptions are honest and the companies actually respond.",
  name: 'Sofia Reyes',
  title: 'Senior UX Designer',
  company: 'Previously at Adobe',
  avatar: "https://randomuser.me/api/portraits/women/44.jpg",
  metric: '2 weeks',
  metricLabel: 'to job offer'
},
{
  type: 'employer',
  quote: "We scaled our remote engineering team from 4 to 12 in under three months using remotejobehire. Every single hire has been a culture and skills fit.",
  name: 'James Whitfield',
  title: 'CTO',
  company: 'Loom',
  avatar: "https://randomuser.me/api/portraits/men/32.jpg",
  metric: '8 hires',
  metricLabel: 'in 90 days'
},
{
  type: 'candidate',
  quote: "I was skeptical at first, but remotejobehire is the real deal. No ghost jobs, no bait-and-switch salary ranges. I found my dream role at a fully distributed startup.",
  name: 'Yuki Tanaka',
  title: 'Data Scientist',
  company: 'Previously at Spotify',
  avatar: "https://randomuser.me/api/portraits/women/68.jpg",
  metric: '$28k',
  metricLabel: 'salary increase'
},
{
  type: 'candidate',
  quote: "As a parent of two, flexibility is non-negotiable. remotejobehire filters out the fake remote jobs so I only see roles that truly respect my schedule.",
  name: 'Lena Hoffmann',
  title: 'Frontend Engineer',
  company: 'Previously at Shopify',
  avatar: "https://randomuser.me/api/portraits/women/12.jpg",
  metric: '100%',
  metricLabel: 'async-friendly roles'
},
{
  type: 'employer',
  quote: "remotejobehire helped us find a DevOps engineer in a niche stack within 10 days. The platform attracts people who are serious about remote work — not just anyone.",
  name: 'Carlos Mendez',
  title: 'Engineering Manager',
  company: 'GitLab',
  avatar: "https://randomuser.me/api/portraits/men/54.jpg",
  metric: '10 days',
  metricLabel: 'to specialist hire'
},
{
  type: 'candidate',
  quote: "I relocated internationally and needed a job that wouldn't penalize me for my timezone. remotejobehire had exactly what I needed — and the application process was seamless.",
  name: 'Kwame Asante',
  title: 'Product Designer',
  company: 'Previously at Canva',
  avatar: "https://randomuser.me/api/portraits/men/76.jpg",
  metric: '4 interviews',
  metricLabel: 'in first week'
},
{
  type: 'employer',
  quote: "We've tried every remote hiring platform out there. remotejobehire consistently delivers candidates who are self-starters and don't need hand-holding. Worth every penny.",
  name: 'Rachel Kim',
  title: 'Director of Talent',
  company: 'Basecamp',
  avatar: "https://randomuser.me/api/portraits/women/29.jpg",
  metric: '92%',
  metricLabel: 'retention after 1 year'
},
{
  type: 'candidate',
  quote: "The job quality on remotejobehire is unmatched. I applied to 5 roles and got 4 callbacks. My previous record on other platforms was 1 callback per 40 applications.",
  name: 'Arjun Patel',
  title: 'Full Stack Developer',
  company: 'Previously at Stripe',
  avatar: "https://randomuser.me/api/portraits/men/18.jpg",
  metric: '4 of 5',
  metricLabel: 'applications got callbacks'
},
{
  type: 'candidate',
  quote: "I was burned out from commuting 3 hours a day. remotejobehire helped me transition to a fully remote role that pays more and respects my time. Life-changing.",
  name: 'Natalie Okonkwo',
  title: 'Marketing Manager',
  company: 'Previously at HubSpot',
  avatar: "https://randomuser.me/api/portraits/women/55.jpg",
  metric: '0 hrs',
  metricLabel: 'daily commute now'
},
{
  type: 'employer',
  quote: "remotejobehire is the only platform where we don't have to wade through hundreds of unqualified applicants. The signal-to-noise ratio is incredible for a remote-first team.",
  name: 'Tom Eriksson',
  title: 'Founder & CEO',
  company: 'Notion',
  avatar: "https://randomuser.me/api/portraits/men/41.jpg",
  metric: '5x',
  metricLabel: 'better applicant quality'
}];


function TestimonialCard({ t, delay }: {t: Testimonial;delay: number;}) {
  const cardRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            cardRef.current?.classList.add('visible');
          }, delay);
          observer.disconnect();
        }
      },
      { threshold: 0.15 }
    );

    if (cardRef.current) observer.observe(cardRef.current);
    return () => observer.disconnect();
  }, [delay]);

  const isCand = t.type === 'candidate';

  return (
    <div
      ref={cardRef}
      className="reveal-up testimonial-card bg-white rounded-xl border border-fog-gray p-6 flex flex-col gap-5">
      
      {/* Badge */}
      <div className="flex items-center justify-between">
        <span className={`text-[10px] font-bold uppercase tracking-widest px-2.5 py-1 rounded-full ${isCand ? 'bg-signal-blue/8 text-signal-blue' : 'bg-slate-pencil/8 text-slate-pencil'}`}>
          {isCand ? '👤 Candidate' : '🏢 Employer'}
        </span>
        {t.metric &&
        <div className="text-right">
            <span className="text-lg font-bold text-signal-blue">{t.metric}</span>
            <p className="text-[10px] text-slate-light leading-none">{t.metricLabel}</p>
          </div>
        }
      </div>

      {/* Quote */}
      <blockquote className="font-serif text-base italic text-slate-dark leading-relaxed flex-1">
        "{t.quote}"
      </blockquote>

      {/* Person */}
      <div className="flex items-center gap-3 pt-3 border-t border-fog-gray/60">
        <AppImage
          src={t.avatar}
          alt={`${t.name}, ${t.title}`}
          width={40}
          height={40}
          className="w-10 h-10 rounded-full object-cover shrink-0" />
        
        <div>
          <p className="text-sm font-semibold text-slate-dark">{t.name}</p>
          <p className="text-xs text-slate-light">{t.title} · {t.company}</p>
        </div>
      </div>
    </div>);

}

export default function Testimonials() {
  return (
    <section className="bg-fog-gray/30 py-20 border-y border-fog-gray">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-12">
          <p className="text-xs font-semibold text-signal-blue uppercase tracking-widest mb-3">Both Sides of the Market</p>
          <h2 className="text-2xl font-semibold text-slate-dark tracking-tight">Everyone is already here</h2>
          <p className="text-sm text-slate-light mt-2 max-w-md mx-auto">Senior professionals and distributed-first teams both trust remotejobehire to find their match.</p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 stagger-children">
          {testimonials.map((t, i) =>
          <TestimonialCard key={t.name} t={t} delay={i * 100} />
          )}
        </div>
      </div>
    </section>);

}